module.exports = __webpack_public_path__ + "img/cackermann1.e1b53980.png";